import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SessionSotrageService } from 'src/services/session-sotrage.service';
import { SweetServices } from '../services/sweet.services';

@Injectable({
  providedIn: 'root'
})
export class AuthorizatedGuard implements CanActivate {


  constructor(private router: Router, private storageService: SessionSotrageService,
              private jwthelper: JwtHelperService, private alerta: SweetServices) { }

  canActivate() {
    if (this.storageService.isAuthenticated() || !this.jwthelper.isTokenExpired(this.storageService.getCurrentToken())) {
        return true;
    } else {
      this.router.navigate(['login']);
      return false;
    }
  }
}
